import { actionType } from "..";
import { SNACKBAR_CLOSE, SNACKBAR_OPEN } from "../action-types/snackbarAction";

export interface SnackbarType {
    open: boolean,
    message: string,
    type: string,
    title: string
}


const initialState = {
    open: false,
    message: "",
    type: "",
    title: ""
} as SnackbarType;

const snackbarReducer = (state = initialState, action: actionType) => {
    switch (action.type) {
        case SNACKBAR_OPEN:
        case SNACKBAR_CLOSE:
            return Object.assign({}, action.payload);
        default:
            return state;
    }
}

export default snackbarReducer;